const xmlHeader =
  '<?xml version="1.0" encoding="UTF-8"?>\n<leerlinggegevens xmlns="http://www.edustandaard.nl/leerresultaten/2/leerlinggegevens" xmlns:xsi= "http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.edustandaard.nl/leerresultaten/2/leerlinggegevens ../XSD_Schemadefinities/UWLR_Leerlinggegevens_v2p3.xsd">\n';

import { j2xParser as Parse2XML } from "fast-xml-parser";
import reorderFields from "./reorderFields";

export default function parseToXMLExport(preparedJSON) {
  var defaultOptions = {
    attributeNamePrefix: "",
    attrNodeName: "key",
    ignoreAttributes: false,
    format: true,
    indentBy: "  ",
    supressEmptyNode: true,
    rootNodeName: "",
  };

  //Reorder pupil object for XML (Xml needs specific order according to UWLR_Leerlinggegevens_v2p3.xsd)
  reorderFields(preparedJSON);
  let xml = new Parse2XML(defaultOptions).parse(preparedJSON);
  xml = `${xmlHeader}${xml}</leerlinggegevens>`;

  return xml;
}
